import { useRuntimeConfig } from "#app";

export const useGetPebbleCmsUrls = () => {
  const config = useRuntimeConfig();

  const cmsBaseUrl = (() => {
    switch (config.public.appEnv) {
      case "production":
        return config.public.productionCMSUrl;
      case "staging":
      case "test":
        return config.public.testCMSUrl;
      default:
        return "http://localhost:3001";
    }
  })();

  const getCreatorJoinUrl = `${cmsBaseUrl}/creators/join`;
  const getContentCreatorDashboardUrl = `${cmsBaseUrl}/dashboard`;

  return { cmsBaseUrl, getCreatorJoinUrl, getContentCreatorDashboardUrl };
};
